/**
 * Pin final actions to the bottom of the viewport / modal (like a footer).
 * Place outside the scrolling region when used in a flex column modal.
 */
export default function StickyActionFooter({ children, className = '' }) {
  return (
    <div
      className={`sticky bottom-0 z-20 shrink-0 border-t border-gray-200 bg-white/95 px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] ${className}`}
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0px))' }}
    >
      {children}
    </div>
  );
}
